import { render, staticRenderFns } from "./report-clients.vue?vue&type=template&id=3f4d0c79&scoped=true"
import script from "./report-clients.vue?vue&type=script&lang=js"
export * from "./report-clients.vue?vue&type=script&lang=js"
import style0 from "./report-clients.vue?vue&type=style&index=0&id=3f4d0c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d0c79",
  null
  
)

export default component.exports